/**
 * Additive admin navigation handoff.
 * Attention Center / League Statistics set a payload; target screens consume once on mount.
 * Does not replace existing filter state when screens open normally (no handoff).
 */

let pendingHandoff = null;

/**
 * @typedef {object} AdminNavHandoff
 * @property {string} [section] target section id
 * @property {string} [seasonId]
 * @property {string} [canton]
 * @property {'all'|'true'|'false'} [isActive] teams active filter
 * @property {boolean} [unassignedDivision]
 * @property {string} [analyticsTab] e.g. 'ops' | 'canton' | 'overview' (League Analytics inner tab)
 * @property {string} [analyticsHubTab] e.g. 'league' | 'deep-dive' | 'attention' | 'registrations' | 'promo' | 'partners' | 'exports'
 * @property {string} [promotionHubTab] e.g. 'season' | 'campaign'
 * @property {string} [matchStatus] e.g. 'completed' | 'scheduled' | 'disputed'
 * @property {string} [registrationOrdersStatus] e.g. 'pending'
 * @property {string} [note] optional UI hint
 */

/** @param {AdminNavHandoff} payload */
export function setAdminNavHandoff(payload) {
  if (!payload || typeof payload !== 'object') {
    pendingHandoff = null;
    return;
  }
  pendingHandoff = { ...payload, _ts: Date.now() };
}

/** @returns {AdminNavHandoff|null} */
export function peekAdminNavHandoff() {
  return pendingHandoff;
}

/** Read and clear handoff (call once when target section mounts). */
export function consumeAdminNavHandoff() {
  const next = pendingHandoff;
  pendingHandoff = null;
  return next;
}

export function clearAdminNavHandoff() {
  pendingHandoff = null;
}
